import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors, ServerError } from '@apollo/client/errors';
import { logger } from '../utils/logger';

interface CreateApolloClientOptions {
  authToken: string;
  tenantId: string;
}

const graphqlUrl: string =
  import.meta.env.VITE_GRAPHQL_URL || 'https://hive-router.robindev.co/graphql';

const extractServerErrorMessages = (error: unknown): string | undefined => {
  if (ServerError.is(error)) return error.bodyText;
};

const errorLink = new ErrorLink(({ error, operation }) => {
  if (CombinedGraphQLErrors.is(error)) {
    const messages = error.errors.map((e) => e.message).join('; ');
    logger.error(
      new Error(`GraphQL error in ${operation.operationName}: ${messages}`, { cause: error })
    );
  } else {
    const messages = extractServerErrorMessages(error);
    logger.error(
      new Error(
        `GraphQL network error in ${operation.operationName}${messages ? `: ${messages}` : ''}`,
        { cause: error }
      )
    );
  }
});

export function createApolloClient({ authToken, tenantId }: CreateApolloClientOptions) {
  const httpLink: ApolloLink = new HttpLink({
    uri: graphqlUrl,
  });

  const authLink = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        Authorization: `Access-Token ${authToken}`,
        'Tenant-Id': tenantId,
      },
    });
    return forward(operation);
  });

  return new ApolloClient({
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache(),
  });
}
